(function preserveWokieeJQuery(wokieeJQuery, window, document) {
  if (!wokieeJQuery) return;

  function restoreWokieeJQuery() {
    window.$ = wokieeJQuery;
    window.jQuery = wokieeJQuery;
  }

  restoreWokieeJQuery();
  wokieeJQuery(restoreWokieeJQuery);
  window.addEventListener('load', restoreWokieeJQuery, { once: true });

  // The product-gallery app loads a second jQuery copy asynchronously and then
  // releases its globals. Restore Wokiee's plugin-bearing instance afterwards.
  window.setTimeout(restoreWokieeJQuery, 250);
  window.setTimeout(restoreWokieeJQuery, 1500);
})(window.jQuery, window, document);
